import React from "react";
import { Box } from "@material-ui/core";
import { useSelector } from "react-redux";

import numberFormatter from "utils/numberFormatter";
import KPIComparator from "components/visuals/KPIComparator";

import { useAppSelector } from "store";
import { selectComparator, selectStore } from "modules/customer/insights/portfolio/portfolioSlice";
import { selectors } from "modules/customer/insights/portfolio/competition/marketShare";

const RevenuePerHousehold = () => {
    const selectedStore = useAppSelector(selectStore);
    const selectedComparator = useAppSelector(selectComparator);
    const revenuePerHousehold = useSelector(state => selectors.revenuePerHousehold(state));
    const { loading, error, value, percentageDifference } = revenuePerHousehold;
    const valueFormatted = numberFormatter.toGBP(value);
    const label = `${selectedStore.name} Revenue Per Household vs ${selectedComparator.name}`;

    return (
        <Box width="100%" height="100%" data-cy="revenue-per-household">
            <KPIComparator loading={loading} error={error} label={label} value={valueFormatted} percentage={percentageDifference} />
        </Box>
    );
};

export default RevenuePerHousehold;
